import { listenCloudStore } from 'service/fireStore';


export const initializeVisitorPrioritization = (config: any, action: any) => (listenCloudStore(config, action));
